
document.addEventListener('DOMContentLoaded', function () {
  // For every bundle cards wrapper on the page
  document.querySelectorAll('[data-variant-cards]').forEach(function (cardsWrapper) {
    var section = cardsWrapper.closest('.shopify-section') || document;
    var variantPicker = section.querySelector('variant-picker');
    var cards = cardsWrapper.querySelectorAll('[data-variant-id]');
    if (!cards.length) return;

    function setActive(id) {
      cards.forEach(function (b) {
        var isActive = b.getAttribute('data-variant-id') === String(id);
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function selectViaNativePicker(id) {
      // 1) Prefer clicking the native picker option (this triggers Rebel media/price updates)
      if (variantPicker) {
        var nativeOption = variantPicker.querySelector('[data-variant-id="' + id + '"] input, [data-variant-id="' + id + '"]');
        if (nativeOption) {
          // If it's a wrapper label/div, click it; if input, click input
          nativeOption.click();
          return true;
        }
      }

      // 2) Fallback: update any add-to-cart forms in this section
      var forms = section.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
      forms.forEach(function (form) {
        var variantField = form.querySelector('input[name="id"]');
        if (variantField) {
          variantField.value = id;
          variantField.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      return false;
    }

    // Initial active state based on URL variant or first card
    try {
      var url = new URL(window.location.href);
      var current = url.searchParams.get('variant');
      if (current) setActive(current);
    } catch (e) {}

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-variant-id');
        if (!id) return;
        selectViaNativePicker(id);
        setActive(id);
      });
    });
  });
});
